import DeveloperIllustration from "./DeveloperIllustration";

export default function Hero() {
  return (
    <section className="relative flex min-h-[100svh] flex-col justify-center px-5 py-12 sm:px-12 sm:py-16 lg:flex-row lg:items-center lg:gap-12 lg:px-16">
      <div className="flex-1 order-2 lg:order-1">
        <p className="mb-3 text-sm font-medium uppercase tracking-widest text-accent-cyan sm:text-base">
          Hello, I'm
        </p>
        <h1 className="text-4xl font-bold mb-3 sm:text-5xl lg:text-6xl sm:mb-4">
          <span className="text-gradient">Roshan Bhogan</span>
        </h1>
        <h2 className="text-lg mb-5 text-gray-300 sm:text-2xl sm:mb-6">
          Full-Stack Developer
        </h2>
        <p className="max-w-xl text-gray-400 mb-8 text-base leading-relaxed sm:text-lg">
          Building scalable web apps with Java, Spring Boot, React, Next.js and AWS —
          including AI-powered features with Amazon Bedrock and production-grade cloud systems.
        </p>
        <div className="flex flex-wrap gap-3 sm:gap-4">
          <a
            href="#experience"
            className="px-6 py-3 rounded-lg font-semibold bg-gradient-to-r from-accent-cyan to-accent-violet text-black transition-opacity hover:opacity-90"
          >
            View Experience
          </a>
          <a
            href="#contact"
            className="px-6 py-3 border border-accent-cyan/50 rounded-lg font-semibold text-accent-cyan transition-colors hover:border-accent-cyan hover:bg-accent-cyan/10"
          >
            Contact Me
          </a>
        </div>
      </div>

      <div className="order-1 mb-8 flex justify-center lg:order-2 lg:mb-0 lg:flex-1">
        <DeveloperIllustration className="w-full max-w-[280px] sm:max-w-xs lg:max-w-sm" />
      </div>

      <div className="pointer-events-none absolute bottom-6 left-1/2 hidden -translate-x-1/2 flex-col items-center gap-2 animate-bounce sm:flex">
        <span className="text-sm text-accent-cyan/60 uppercase tracking-widest">Scroll</span>
        <a href="#about" className="pointer-events-auto">
          <svg
            className="w-6 h-6 text-accent-violet"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </a>
      </div>
    </section>
  );
}
